var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('affiliate-invoices-wrap',{attrs:{"title":`Мастер-аккаунт ${_vm.$route.params.id}: счета my.leadgid`,"api-method-invoices":_vm.getMasterAccountMyLeadgidInvoices,"filters":_vm.filters,"transform-submited-params":_vm.transformParamsObjBeforeSubmit,"columns":_vm.columns,"table-headers":_vm.tableHeaders}})
}
var staticRenderFns = []

export { render, staticRenderFns }